export enum ProductActivationType {
  QRIS,
  Shopee,
  LinkAja,
  DANA,
}
